// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgThermostatIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M9.5 7c-.28 0-.5.22-.5.5V10h1V7.5c0-.28-.22-.5-.5-.5" />
    <path d="M17 3H7C4.79 3 3 4.79 3 7v10c0 2.21 1.79 4 4 4h10c2.21 0 4-1.79 4-4V7c0-2.21-1.79-4-4-4m-3.5 3h1c.28 0 .5.22.5.5s-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5m-4 12A2.5 2.5 0 0 1 7 15.5c0-.82.4-1.53 1-1.99V7.5C8 6.67 8.67 6 9.5 6s1.5.67 1.5 1.5v6.01c.6.46 1 1.17 1 1.99A2.5 2.5 0 0 1 9.5 18m5-5h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5m3-3h-4c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h4c.28 0 .5.22.5.5s-.22.5-.5.5" />
  </g>
);
export default SvgThermostatIcon;
SvgThermostatIcon.displayName = 'SvgThermostatIcon';
